// extracted by mini-css-extract-plugin
module.exports = {"thecomp":"AU2_thecomp__5S7Px"};